import "core-js/stable";
import "regenerator-runtime/runtime";
import "./style/stylesheets/styles.scss";
import MocaTheme from "./javascript/moca-theme.js";

const theme = new MocaTheme();
theme.init();
